module.exports = __webpack_public_path__ + "img/Villa_Borna_64.aab1f92f.jpg";